/**
 * atomberg-pdf-links.js
 * ──────────────────────
 * Admin rich-text page content (page.content, rendered inside
 * <rte-formatter>) has no way to set a link's target — the Admin editor's
 * link picker doesn't expose it. This finds every PDF link inside page body
 * content and opens it in a new tab, so editors don't have to hand-edit the
 * page's HTML source to add target="_blank" themselves.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergPdfLinksInit) return;
  w._atombergPdfLinksInit = true;

  function wire() {
    document.querySelectorAll('rte-formatter a[href]').forEach(function (link) {
      var href = /** @type {HTMLAnchorElement} */ (link).href.toLowerCase();
      var isPdf = href.indexOf('.pdf') !== -1;
      if (!isPdf) return;
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
